export namespace CommonUtils {
  /**
   * Check whether value is null / undefined or not.
   *
   * @export
   * @param {*} value
   * @return {*}  {boolean}
   */
  export function isNullOrUndefined(value: any): boolean {
    if (value === null || value === undefined) {
      return true;
    }
    return false;
  }

  /**
   * Convert object to JSON string.
   *
   * @export
   * @param {*} obj
   * @return {*}  {string}
   */
  export function toJSON(obj: any): string {
    return JSON.stringify(obj);
  }

  /**
   * Deep copy object.
   *
   * @export
   * @template T
   * @param {T} obj
   * @return {*}  {T}
   */
  export function deepCopy<T>(obj: T): T {
    if (isNullOrUndefined(obj)) {
      return obj;
    }

    const dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.*)/;

    function reviver(key: string, value: any): any {
      if (typeof value === 'string' && dateFormat.test(value)) {
        return new Date(value);
      }
      return value;
    }

    return JSON.parse(JSON.stringify(obj), reviver);
  }
}
